// Export stores
export {
  useConnectionStore,
  useSubscriptionStore,
  useMetricsStore,
  useWebSocketUIStore,
  ConnectionStatus,
  useConnectionStatus,
  useIsConnected,
} from './websocket.store';

// Export hooks
export {
  useWebSocket,
  useWebSocketEvent,
  useWebSocketChannel,
  useWebSocketStatus,
  useWebSocketMetrics,
  useWebSocketMessages,
  useWebSocketGlobalHandler,
  usePrivateChannel,
} from './hooks';

// Export instant handler registry
export { onInstant } from './realtime-sync.registry';

// Export mutation lock API
export { setMutationLock, clearMutationLock } from './realtime-sync.locks';

// Export provider
export { WebSocketProvider } from './websocket-provider';

// Export utilities
export { initializeAbly } from './ably-init';
export {
  getBroadcastCoordinator,
  destroyBroadcastCoordinator,
} from './broadcast-coordinator';
export { disconnectEchoSingleton } from './websocket-singleton';

// Export types
export type { BroadcastMessage } from './broadcast-coordinator';
export type {
  DataChangedEvent,
  DataChangedEntity,
  DataChangedAction,
  InstantHandler,
  BatchEventPayload,
  WebSocketEventMap,
} from './types';

export type {
  WebSocketMessage,
  WebSocketChannel,
  WebSocketMetrics,
  WebSocketSubscription,
} from './websocket.store';
